// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"d052122b","453":"80efc53e","782":"ba6345ca"}[chunkId] + ".chunk.js";
};